import React from 'react'
import '../Css/styles2.css'
import '../Css/bootstrap.css'
import { ins_img } from "./images"


function Inspiration() {
    return (
        <div>
            <section className="about-us">
                <h2 className='headinforinsipiration'>Our Inspiration</h2>
                <div className="about">
                <img src='/20220430_080215.jpg' className="pic" style={{ width: '11.5rem', height: '18.75rem' }} />
                    <div className="text">
                        <br />

                        <p>Almost every individual find themselves inspired by some or the other person in various aspects of
                            life.Being a retired ARMY OFFICER, career goals, entrepreneurial endeavors, the guidance and
                            encouragement along with the down to earth legacy provided by them act as a driving force.The
                            lessons learned at their hands,such as the importance of hard work, perseverance, and integrity,
                            often become the foundation upon which their children build their own aspirations and dreams.The
                            unwavering support and belief that they offer can instill the confidence needed to take on
                            challenges and reach for success.We are very thankful to you for constantly inspiring and providing
                            a source of motivation and guidance.<span><q>We love you!</q></span></p>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Inspiration